export const PROGRESS_HISTORY_LOADING_LIMIT = 1000;
export const TRAINING_ID = 1;
export const NUMBER_OF_TENDENCY_LAST_GAMEPLAYS = 4;
export const WHICH_BEST_RESULT = 5;
export const LAST_GAME_PLAYS_FOR_BEST_RESULTS = 25;
